import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { ValidState } from "@/models/enum/Enum";

type Props = {
  value?: ValidState;
  label?: string;
};
type Emits = {
  (e: "input", val?: ValidState): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ValidSelect',
  props: {
    value: null,
    label: { default: "状態" }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val?: ValidState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: ValidState, label: string };

const items = [
  { text: "有効", value: ValidState.Valid },
  { text: "無効", value: ValidState.InValid }
] as const;




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

return { __sfc: true,items, props, emits, modelValue }
}

})